<template>
  <div class="story">
    <nav>
      <TopNav />
    </nav>
    <div class="page1">
      <img class="mask-bg" src="../../assets/image/story.jpg"/>
      <div class="text">
        <div class="left">
          <div class="title">专业家用产后修复品牌</div>
          <div class="intro">
            <p>雅致医疗前身为医院大器械供货商，拥有全国领先的产后修复医疗器械研发技术。</p>
            <p>在大型治疗设备的基础上创新治疗场景，让患者居家即可完成产后相关评估与治疗康复。</p>
            <p>雅致医疗致力于成为一家集家用医疗器械研发、生产、销售及互联网信息医疗服务为一体的产后修复第一品牌。</p>
          </div>
        </div>
      </div>
    </div>
    <div class="page2">
      <div class="video-wrapper">
        <video  id=”media” :src="videoUrl" controls  muted :poster="require('../../assets/image/indexBg.jpg')"></video>
        <div class="list">
          <div v-for="(item,itemInd) in newsList" :key="itemInd">
            <div>{{item.title}}</div>
            <div>{{item.subTitle}}</div>
            <button @click="goToLink(item.link)">查看更多</button>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>
<script>
import TopNav from "./components/TopNav.vue";
import Footer from "./components/Footer.vue";

export default {
  name: "About",
  components: {Footer, TopNav},
  data(){
    return {
      videoUrl: 'https://dsmm-elechcy.oss-cn-shenzhen.aliyuncs.com/owe/prod/home/yc_chanpian_B_359.mp4',
      newsList: [
        {title:'雅致医疗开展“关注盆底健康',subTitle: '呵护女性幸福”公益讲座',id :'1',link: 'https://www.163.com/news/article/HQLCQGTJ00019UD6.html'},
        {title:'雅致医疗线上线下心理沙龙活动正式启动',subTitle: '赋能妈妈成为更好的自己',id :'2',link: 'https://www.pcpop.com/article/6786404.shtml'},
        {title:'雅致医疗年会',subTitle: '以质量树口碑，以服务得人心',id :'3',link: 'https://www.163.com/news/article/HVSLTRQO00019UD6.html'},
        {title:'官宣！雅致医疗IP形象“小雅”',subTitle: '软萌上线啦',id :'4',link: 'https://tech.ifeng.com/c/8OChwbZzq6V'},
        {title:'有颜值有实力！',subTitle: '雅致医疗盆底肌治疗仪获外观专利',id :'5',link: 'https://www.163.com/news/article/I7CB3BPP00019UD6.html'}
      ]
    }
  },
  methods: {
    goToLink(link) {
      window.open(link)
    }
  }
}
</script>
<style lang="less"  scoped>
.story {
  height: 100%;
  font-size: 16px;
  .page1 {
    height: 100%;
    position: relative;
    overflow: hidden;
    img {
      min-height: 100%;
      display: block;
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: -1;
    }
    .text {
      position: absolute;
      top: 34%;
      left: 25%;
      width: 50%;
      max-width: 1024px;
      .left {
        width: 500px;
        .title {
          font-size: 26px;
          color: #D3AF8B;
        }
        .intro p {
          line-height: 23px;
          color: #646464;
        }
      }
    }
  }
  .page2 {
    height: 100%;
    padding-top: 220px;
    background: url("../../assets/image/news.jpg") no-repeat 0 0/100% 100%;
    .video-wrapper {
      video {
        width: 40%;
        max-width: 1024px;
        margin: 0 auto;
        display: block;
      }
      .list {
        display: flex;
        flex-direction: row;
        justify-content: center;
        margin-top: 80px;
        >div {
          margin: 0 15px;
          text-align: center;
          color: #999999;
          line-height: 25px;
        }
        button {
          color: #999999;
          border: 1px solid #999999;
          -webkit-border-radius: 5px;
          border-radius: 5px;
          width: 100px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          background: none;
          margin-top: 18px;
          cursor: pointer;
        }
        >div:hover {
          color: #090404;
          button {
            color: #ffffff;
            border: none;
            font-size: 15px;
            background: linear-gradient(to right,#DDC4A9,#D2B08C);
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/new/Story.vue